import { render } from "./Home.vue?vue&type=template&id=57570b82"
const script = {}
script.render = render

export default script